export default class HttpError extends Error {
    /** @type {Number} */ statusCode = null
    /** @type {String} */ statusMessage = null

    constructor(statusCode, statusMessage) {
        super(`${statusCode} ${statusMessage}`)
        this.statusCode = statusCode
        this.statusMessage = statusMessage
    }
}